<template>
  <div>
    <ModalMap v-if="data?.vessel" :vessel="data?.vessel" class="map"></ModalMap>

    <div class="mt-4">
      <KpCell style="margin-right: 14px" :kp="kp"></KpCell>
      <CoordinateCell
        :coordinates="[coordinate?.latitude ?? 0, coordinate?.longitude ?? 0]"
      ></CoordinateCell>
    </div>

    <div class="mt-1">
      <div v-for="(property, index) in firstSection" :key="index">
        <span class="property">{{ property.name }}</span> {{ property.value }}
      </div>
    </div>

    <div class="mt-4" v-if="data?.comment">
      <span class="property comment">Comment:</span> {{ data?.comment }}
    </div>

    <div class="mt-4">
      <div class="second-section-grid" v-if="secondSection.length">
        <div v-for="(property, index) in secondSection" :key="index" class="property-item">
          <span class="property">{{ property.name }}</span> {{ property.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ModalMap from '@/components/maps/ModalMap.vue'
import { AlarmAISData, Coordinate } from '@/server/MakeSenseApp-backend'
import { defineProps, onMounted, ref } from 'vue'
import CoordinateCell from '../cells/CoordinateCell.vue'
import KpCell from '../cells/KpCell.vue'
var firstSection = ref<{ name: string; value: string }[]>([])
var secondSection = ref<{ name: string; value: string }[]>([])

var props = defineProps({
  data: AlarmAISData,
  kp: Number,
  coordinate: Coordinate
})

onMounted(() => {
  firstSection.value = [
    { name: 'Vessel:', value: props.data?.vesselName ?? '-' },
    { name: 'Zone:', value: props.data?.zone ?? '-' }
  ]

  secondSection.value = [
    { name: 'Rule Group:', value: props.data?.ruleGroup ?? '-' },
    { name: 'MMSI:', value: props.data?.mmsi?.toString() ?? '-' },
    { name: 'Length, Breadth:', value: props.data?.length + ', ' + props.data?.breadth },
    { name: 'Destination:', value: props.data?.destination ?? '-' },

    { name: 'Speed over ground:', value: props.data?.speedOverGround?.toFixed(2) ?? '-' },
    { name: 'Course over ground:', value: props.data?.courseOverGround?.toFixed(2) ?? '-' },
    { name: 'Radio call sign:', value: props.data?.radioCallSign ?? '-' }
  ]
})
</script>

<style scoped lang="scss">
@use '@/styles/ms-color-styles.scss' as color;

.property {
  font-weight: 500;
  margin-right: 10px;
}

.property.comment {
  color: color.$color-dark-grey;
}

.map {
  width: 100%;
  height: 400px;
}

.second-section-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.property-item {
  flex: 1 1 45%; /* Adjust to control width of columns */
  display: flex;
}
</style>
